import { FC, useEffect } from "react";
import { useTranslation } from "next-i18next";

import FilterPopover from "./filter-popover";
import RangeFilter from "./range-filter";

import { ActionType, Range } from "@interfaces/filters";
import { useFilters } from "@context/filter";

interface Props {
  range: Range;
  className?: string;
}

const PriceFilter: FC<Props> = ({ range: [min, max], className }) => {
  const {
    filters: { price: values },
    dispatch,
  } = useFilters();
  const { t } = useTranslation("category");

  useEffect(() => {
    if (values[1] > max) {
      dispatch({ type: ActionType.SET_PRICE, value: [min, max] });
    }
  }, [max, min, values, dispatch]);

  return (
    <FilterPopover {...{ text: t("filters.price.label"), className }}>
      <RangeFilter
        {...{
          values,
          text: "",
          type: ActionType.SET_PRICE,
          min,
          max,
          step: 1,
          price: true,
        }}
      />
    </FilterPopover>
  );
};

export default PriceFilter;
